import React from "react";
import { Container, Typography, Toolbar, AppBar, Link } from "@mui/material";
import Atras from "./atras";
import BottomNav from "./BottomNav";

const Perfil = () => {
  const styles = {
    cont: {
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
      textAlign: "center",
      margin: 0,
      padding: 0,
      boxSizing: "border-box",
    },
    user: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      width: "100%",
      height: "90px",
      marginTop: "10px",
    },
  };
  return (
    <Container>
      <AppBar position="fixed">
        <Toolbar
          sx={{
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <Atras color="inherit" />

          <Container style={styles.user}>
            <Typography variant="h5" color="text.primary" gutterBottom>
              Política y Privacidad
            </Typography>
          </Container>
        </Toolbar>
      </AppBar>
      <Container sx={{ mt: 16, mb: 16 }}>
        <Container
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            width: "100%",
            textAlign: "left",
            marginTop: "20px",
          }}
        >
          <Typography variant="subtitle1" component="div" gutterBottom>
            <h1>Política de Privacidad</h1>
            <p>Última actualización: 1 de septiembre de 2026</p>
            <p>
              En Skach (operada por Dapur Tecnología) nos tomamos en serio tu
              privacidad. Esta Política de Privacidad explica qué datos
              recopilamos cuando usás la aplicación, cómo los usamos y cuáles
              son tus derechos sobre ellos.
            </p>

            <h2>1. Datos que recopilamos</h2>
            <p>Cuando usás Skach podemos recopilar:</p>
            <ul>
              <li>
                <p>
                  <strong>Datos de tu cuenta:</strong> nombre, email, teléfono,
                  localidad y tipo de usuario (Cliente o Freelancer).
                </p>
              </li>
              <li>
                <p>
                  <strong>Datos de perfil:</strong> foto de perfil, biografía,
                  habilidades, portfolio, certificaciones y enlaces (LinkedIn,
                  GitHub, sitio web) que decidas compartir.
                </p>
              </li>
              <li>
                <p>
                  <strong>Contenido que generás:</strong> proyectos,
                  propuestas, mensajes de chat y reseñas.
                </p>
              </li>
              <li>
                <p>
                  <strong>Datos de pago:</strong> cuando contratás una
                  suscripción, el pago se procesa a través de PayPal o Mercado
                  Pago; Skach no almacena los números completos de tu tarjeta.
                </p>
              </li>
              <li>
                <p>
                  <strong>Datos de uso:</strong> información técnica como el
                  dispositivo y el navegador que usás, para poder mejorar la
                  aplicación.
                </p>
              </li>
            </ul>

            <h2>2. Cómo usamos tus datos</h2>
            <p>Usamos tus datos para:</p>
            <ul>
              <li>Crear y administrar tu cuenta;</li>
              <li>Conectarte con otros usuarios de la Plataforma;</li>
              <li>Procesar pagos y suscripciones;</li>
              <li>
                Enviarte notificaciones relevantes (propuestas, mensajes,
                pagos);
              </li>
              <li>
                Moderar el contenido y las conversaciones para proteger a la
                comunidad;
              </li>
              <li>Mejorar la Plataforma.</li>
            </ul>

            <h2>3. Con quién compartimos tus datos</h2>
            <p>No vendemos tus datos personales. Los compartimos únicamente con:</p>
            <ul>
              <li>
                <p>
                  <strong>Otros usuarios:</strong> tu nombre, tu foto y tu
                  perfil son visibles para otros usuarios de la Plataforma
                  según tu rol.
                </p>
              </li>
              <li>
                <p>
                  <strong>Proveedores de infraestructura:</strong> usamos
                  Firebase (Google Cloud) para alojar la base de datos, la
                  autenticación y el almacenamiento de archivos.
                </p>
              </li>
              <li>
                <p>
                  <strong>Procesadores de pago:</strong> PayPal y Mercado Pago
                  procesan los pagos de las suscripciones.
                </p>
              </li>
              <li>
                <p>
                  <strong>Autoridades:</strong> cuando la ley nos obligue a
                  hacerlo.
                </p>
              </li>
            </ul>

            <h2>4. Cookies y almacenamiento local</h2>
            <p>
              Usamos el almacenamiento local de tu navegador (localStorage)
              para recordar preferencias como el modo claro/oscuro y evitar
              volver a mostrarte avisos que ya cerraste. No usamos cookies de
              publicidad de terceros.
            </p>

            <h2>5. Seguridad</h2>
            <p>
              Protegemos tus datos con las medidas de seguridad de Firebase
              (Google Cloud), incluyendo reglas de acceso a la base de datos y
              autenticación. Ningún sistema es 100% seguro, pero trabajamos
              para minimizar los riesgos.
            </p>

            <h2>6. Retención y eliminación de tus datos</h2>
            <p>
              Guardamos tus datos mientras tu cuenta esté activa. Si eliminás
              tu cuenta desde la sección "Eliminar cuenta" de tu perfil,
              borramos tu información personal y tu acceso a la Plataforma de
              forma permanente, salvo los datos que estemos obligados a
              conservar por ley (por ejemplo, registros de pagos).
            </p>

            <h2>7. Tus derechos</h2>
            <p>
              Podés acceder, corregir o eliminar tus datos personales en
              cualquier momento desde tu perfil, o escribiéndonos a{" "}
              <Link href="mailto:support@notiline.com">
                support@notiline.com
              </Link>
              .
            </p>

            <h2>8. Menores de edad</h2>
            <p>
              Skach no está dirigida a menores de 18 años y no recopilamos
              intencionalmente datos de menores.
            </p>

            <h2>9. Cambios a esta política</h2>
            <p>
              Podemos actualizar esta Política de Privacidad. Vamos a publicar
              cualquier cambio importante en esta página y a actualizar la
              fecha de "Última actualización".
            </p>

            <h2>10. Contacto</h2>
            <p>
              Si tenés preguntas sobre esta Política de Privacidad, escribinos
              a{" "}
              <Link href="mailto:support@notiline.com">
                support@notiline.com
              </Link>
              .
            </p>
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 4, mb: 2 }}>
            © 2026 Skach - Dapur Tecnología. Todos los derechos reservados.
          </Typography>
        </Container>
      </Container>
      <BottomNav />
    </Container>
  );
};

export default Perfil;
